import { LOAD_INFO } from '../actions.type';
import initialState from '../initialState';

export default function(state = initialState.info, action) {
  switch (action.type) {
    case LOAD_INFO:
      return {...action.info, ready: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/info/info.reducer.js